import { CreateTicketNoteRequest, CreateTicketRequest, UpdateTicketRequest } from "@telegraphio/bapi-types";
import { customerSupportApi } from "../adapters/customerSupport";
import { useEnhancedMutation } from "./useEnhancedMutation";
import { queryClient } from "@/plugins/vueQuery";

// --
// Tickets
// --
export function useCreateTicket() {
  return useEnhancedMutation({
    mutationKey: ["create-ticket"],
    mutationFn: async ({ customerId, requestData }: { customerId: string; requestData: CreateTicketRequest }) => {
      const response = await customerSupportApi.createTicket(customerId, requestData);
      return response;
    },
    onSuccess: (data, { customerId }) => {
      queryClient.invalidateQueries({ queryKey: ["tickets", customerId] });
    },
  });
}

export function useUpdateTicket() {
  return useEnhancedMutation({
    mutationKey: ["update-ticket"],
    mutationFn: async ({
      customerId,
      ticketId,
      requestData,
    }: {
      customerId: string;
      ticketId: string;
      requestData: UpdateTicketRequest;
    }) => await customerSupportApi.updateTicket(customerId, ticketId, requestData),
    onSuccess: (data, { customerId, ticketId }) => {
      queryClient.setQueryData(["ticket", customerId, ticketId], data);
      queryClient.invalidateQueries({ queryKey: ["tickets", customerId] });
    },
  });
}

export function useDeleteTicket() {
  return useEnhancedMutation({
    mutationKey: ["delete-ticket"],
    mutationFn: async ({ customerId, ticketId }: { customerId: string; ticketId: string }) =>
      await customerSupportApi.deleteTicket(customerId, ticketId),
    onSuccess: (data, { customerId }) => {
      queryClient.invalidateQueries({ queryKey: ["tickets", customerId] });
    },
  });
}

// --
// Ticket Notes
// --
export function useCreateTicketNote() {
  return useEnhancedMutation({
    mutationKey: ["create-ticket-note"],
    mutationFn: async ({
      customerId,
      ticketId,
      requestData,
    }: {
      customerId: string;
      ticketId: string;
      requestData: CreateTicketNoteRequest;
    }) => await customerSupportApi.createTicketNote(customerId, ticketId, requestData),
    onSuccess: (data, { customerId, ticketId }) => {
      queryClient.invalidateQueries({ queryKey: ["ticketNotes", customerId, ticketId] });
    },
  });
}
